<template>
  <div>
    <component :is="getModuleTagByTypeId(m.moduleTypeId).tag" v-for="(m,i) in this.modules" :key="`module_${i}`" :settings="m.moduleSettings" />
  </div>
</template>
<script>
export default {
  props: {
    areaId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    modules() {
      if (this.$store.getters['modules/getCurrentModules']) {
        return this.$store.getters['modules/getCurrentModulesByAreaId'](this.areaId);
      }
    },
  },
  methods: {
    getModuleTagByTypeId(typeId) {
      return this.$store.state.modules.allModuleTypes.find((o) => o.id === typeId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/config.scss";

h1 {
  text-align: center;
  font-family: $font-family-editorial;
  font-size: 28px;
  line-height: 35px;
  font-weight: 400;
  margin: 0 auto;
  padding: 0 0 16px;
  border-bottom: 0 solid $solitude;
  display: block;
}
h3 {
  text-align: center;
  border-bottom: 1px solid $solitude;
  font-size: 14px;
  display: inline-block;
  font-weight: 500;
  text-transform: uppercase;
}

img {
  width: 100%;
}

a {
  color: $ochre;
}
</style>
